import { Box, Container } from '@mui/material';
import React from 'react'
import "./styles/splashScreen.css"
// import {ReactComponent as NewLogo} from "../../assets/icons/newLogo.svg"
import LogoSvg from '../../components/ui/LogoSvg';

const SplashScreen = ({logoUp}) => {
  return (
    <>
      <Container maxWidth="xl">
        <Box className="logo">
          {/* <Logo /> */}
          <LogoSvg height={logoUp? "5.5vw" :'11vw'} width={logoUp? "7vw" :"14vw"}/>
        </Box>
      </Container>
    </>
  )
}

export default SplashScreen;